export function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-updated">Last Updated: February 9, 2026</p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Introduction</h2>
            <p>
              GlitchedDeals ("we," "our," or "us") is committed to protecting your privacy.
              This Privacy Policy explains how we collect, use, and share information about you
              when you use our website and services.
            </p>
          </section>

          <section className="legal-section">
            <h2>Information We Collect</h2>
            <h3>Information You Provide</h3>
            <p>
              When you interact with our services, we may collect:
            </p>
            <ul>
              <li>Discord username and ID when you join our Discord community</li>
              <li>Social media handles when you follow or interact with us</li>
              <li>Feedback, questions, or comments you submit to us</li>
            </ul>

            <h3>Information Collected Automatically</h3>
            <p>
              When you visit our website, we automatically collect certain information, including:
            </p>
            <ul>
              <li>Browser type and version</li>
              <li>IP address and general location</li>
              <li>Pages visited and time spent on pages</li>
              <li>Referring website</li>
              <li>Device information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Send you deal alerts and notifications (if you opt in)</li>
              <li>Communicate with you about our services</li>
              <li>Analyze usage patterns and trends</li>
              <li>Prevent fraud and abuse</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Information Sharing</h2>
            <p>
              We do not sell your personal information. We may share your information with:
            </p>
            <ul>
              <li><strong>Third-Party Services:</strong> Discord, Twitter/X, and other platforms we use to provide our services</li>
              <li><strong>Analytics Providers:</strong> To help us understand how our services are used</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Third-Party Links</h2>
            <p>
              Our website and services contain links to third-party websites and retailers.
              We are not responsible for the privacy practices of these external sites.
              We encourage you to review their privacy policies.
            </p>
          </section>

          <section className="legal-section">
            <h2>Data Retention</h2>
            <p>
              We retain your information for as long as necessary to provide our services
              and comply with legal obligations. You may request deletion of your data
              by contacting us.
            </p>
          </section>

          <section className="legal-section">
            <h2>Your Rights</h2>
            <p>
              Depending on your location, you may have certain rights regarding your personal information, including:
            </p>
            <ul>
              <li>Access to your personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your information</li>
              <li>Opt-out of marketing communications</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Children's Privacy</h2>
            <p>
              Our services are not intended for children under 13. We do not knowingly
              collect information from children under 13. If you believe we have collected
              information from a child under 13, please contact us.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of
              any changes by posting the new Privacy Policy on this page and updating the
              "Last Updated" date.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us:
            </p>
            <ul>
              <li>Via Discord: <a href="https://discord.gg/explorer" target="_blank" rel="noopener noreferrer">discord.gg/explorer</a></li>
              <li>Via Twitter/X: <a href="https://twitter.com/GlitchedDeals" target="_blank" rel="noopener noreferrer">@GlitchedDeals</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
